import React, { useEffect, useState } from 'react';
import './Contact.css';

import Banner from '../Alumni/Partials/Banner';
import DynamicBanner from '../include/DynamicBanner';
import api from '../../../api';

const Contact = () => {

  const [activeTab, setActiveTab] = useState('care');
  const [showMoreRows, setShowMoreRows] = useState(false);
  const [expandedMemberIndex, setExpandedMemberIndex] = useState(null);

  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // FORMAT ALL NON-BANNER IMAGES → /public/...
  const formatImage = (img) => {
    if (!img) return null;
    if (img.startsWith("http")) return img;
    return `${process.env.REACT_APP_API_URL}/public/${img.replace(/^\//, "")}`;
  }; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/api/sitepages/academic/contact-us");
        const data = res?.data?.data || null;

        if (!data) {
          setContactData(null);
          setIsLoading(false);
          return;
        }

        // BANNER IMAGES — DO NOT USE /public
        const bannerImagesDesktop =
          (data.banner_images || [])
            .map(img => img ? `/${img.replace(/^\//, '')}` : null)
            .filter(Boolean);

        // ❌ NEVER USE mobile banner
        const bannerImagesMobile =  (data.mobile_banner_images|| [])
            .map(img => img ? `/${img.replace(/^\//, '')}` : null)
            .filter(Boolean);

        // MEMBERS — use /public
        const members = (data.chettinad_members || []).map(m => ({
          ...m,
          image: formatImage(m.image),
          contacts: m.contacts || []
        }));

        const constituent_college = data.constituent_college || [];
        const other_enquiry = data.other_enquiry || [];

        setContactData({
          banner_title: data.banner_title,
          bannerImagesDesktop,
          bannerImagesMobile,
          sub_headings: data.sub_headings || {},
          members,
          constituent_college,
          other_enquiry
        });

        setIsLoading(false);

      } catch (err) {
        console.error("Error fetching Contact data:", err);
        setError("Failed to load contact data");
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleRows = () => setShowMoreRows(!showMoreRows);

  const toggleMember = (index) => {
    setExpandedMemberIndex(prev => (prev === index ? null : index));
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5">
        <h4>{error}</h4>
        <button className="btn btn-primary mt-3" onClick={() => window.location.reload()}>
          Try Again
        </button>
      </div>
    );
  }

  if (!contactData) {
    return (
      <div className="text-center py-5">
        <h4>No contact data available.</h4>
      </div>
    );
  }

  const {
    banner_title,
    bannerImagesDesktop,
    bannerImagesMobile,
    sub_headings,
    members,
    constituent_college,
    other_enquiry
  } = contactData;

  const tabCareTitle = sub_headings?.sub_heading_1 || '';
  const tabConstituentTitle = sub_headings?.sub_heading_2 || '';
  const tabOthersTitle = sub_headings?.sub_heading_3 || '';

  const VISIBLE_ROW_COUNT = 6;

  return (
    <>
      {/* BANNER */}
      {(bannerImagesDesktop?.length > 0) ? (
        <DynamicBanner
          title={banner_title}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      ) : <Banner />}

      <section className="contact-page">
        <div className="container">
          <div className="sec-title text-center"><h2>Contact us</h2></div>

          {/* Tabs */}
          <ul className="nav nav-tabs main-tab-contact d-flex justify-content-center">
            {tabCareTitle && (
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'care' ? 'active' : ''}`}
                  onClick={() => setActiveTab('care')}
                >
                  {tabCareTitle}
                </button>
              </li>
            )}

            {tabConstituentTitle && (
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'constituent' ? 'active' : ''}`}
                  onClick={() => setActiveTab('constituent')}
                >
                  {tabConstituentTitle}
                </button>
              </li>
            )}

            {tabOthersTitle && (
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'others' ? 'active' : ''}`}
                  onClick={() => setActiveTab('others')}
                >
                  {tabOthersTitle}
                </button>
              </li>
            )}
          </ul>

          {/* CARE TAB */}
          <div className="tab-content">

            <div className={`tab-pane fade ${activeTab === 'care' ? 'show active' : ''}`}>
              <div className="row g-4 mt-2">

                {members.map((member, idx) => (
                  <div key={idx} className="col-md-4 mb-md-3">
                    <div className="profile-card">

                      <div className="profile-image-container">
                        {member.image && <img src={member.image} className="profile-image" />}
                      </div>

                      <div className="role-badge">{member.roll}</div>
                      <h3 className="profile-name">{member.name}</h3>

                      <div className="text-center">
                        <button
                          className="btn btn-view-more mt-2"
                          onClick={() => toggleMember(idx)}
                        >
                          {expandedMemberIndex === idx ? 'Hide Contact Info' : 'View Contact Info'}
                        </button>
                      </div>

                      {expandedMemberIndex === idx && (
                        <div className="mt-3">
                          <div className="contact-section-contact">

                            {member.contacts.length > 0 ? (
                              member.contacts.map((c, i) => (
                                <div key={i} className="contact-item">
                                  <div className="contact-icon-contact">
                                    <i className={c.icon_class}></i>
                                  </div>
                                  <div className="contact-details-contact">
                                    <div className="contact-label">{c.contact_name}</div>
                                    <div className="contact-value">{c.contact_id}</div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-center m-0">No contact info available.</p>
                            )}

                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                ))}

              </div>
            </div>

            {/* CONSTITUENT TABLE */}
            <div className={`tab-pane fade mt-5 ${activeTab === 'constituent' ? 'show active' : ''}`}>
              <div className="table-responsive">

                {constituent_college.map((tbl, tIndex) => {
                  const allRows = tbl.rows || [];
                  const visibleRows = showMoreRows ? allRows : allRows.slice(0, VISIBLE_ROW_COUNT);

                  return (
                    <table key={tIndex} className="table table-bordered align-middle">
                      <thead>
                        <tr>
                          {tbl.columns.map((col, cIndex) => <th key={cIndex}>{col}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleRows.map((row, rIdx) => (
                          <tr key={rIdx}>
                            {row.map((cell, cIdx) => <td key={cIdx}>{cell}</td>)}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  );
                })}

               

              </div>
               {constituent_college.some(tbl => tbl.rows.length > VISIBLE_ROW_COUNT) && (
                  <div className="text-center mt-3 mb-3">
                    <button className="btn btn-about-contact" onClick={toggleRows}>
                      {showMoreRows ? 'Read Less' : 'Read More'}
                    </button>
                  </div>
                )}
            </div>

            {/* OTHER ENQUIRIES */}
            <div className={`tab-pane fade ${activeTab === 'others' ? 'show active' : ''}`}>
              <div className="row mt-5">

                {other_enquiry.map((section, idx) => (
                  <div key={idx} className="col-md-4 mb-3">
                    <div className="card contact-card-contact shadow-sm">
                      <div className="card-body">
                        <h5 className="fw-semibold mb-2 text-start">
                          {section.heading}
                        </h5>

                        {section.items.map((item, iIdx) => (
                          <p key={iIdx}>
                            <i className={`${item.icon_class} me-2`}></i>
                            {item.name}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
